import React from 'react';
import './TextInput.scss';

interface TextInputProps {
  label?: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  error?: string;
  type?: string;
  min?: number;
  max?: number;
  disabled?: boolean;
  placeholder?: string;
  maxLength?: number;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  value,
  onChange,
  required,
  error,
  type = 'text',
  min,
  max,
  disabled = false,
  placeholder,
  maxLength,
}) => {
  return (
    <div className="text-input-container">
      {label && (
        <label>
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <input
        className={`text-input-field${error ? ' with-error' : ''}${disabled ? ' disabled' : ''}`}
        type={type}
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={maxLength}
      />
      {error && <div className="text-input-error">{error}</div>}
    </div>
  );
};

export default TextInput;
